import React, { lazy, Suspense } from 'react';
import TrackVisibility from "react-on-screen";

import useEstadistica from '../hooks/use-estadistica';
import useAbout from '../hooks/use-about';

const Estadistica = lazy(() => import('./estadistica'));

const renderLoader = () => <p>Loading</p>;

const About = () => {

    const estadisticas = useEstadistica();
    const dataAbout = useAbout();

    return (  
        <section id="about" className="section">
            <div className="container px-lg-5">
                <div className="position-relative d-flex text-center mb-5">
                    <h2 className="text-24 text-light opacity-4 text-uppercase font-weight-600 w-100 mb-0">About Me</h2>
                    <p className="text-9 text-dark font-weight-600 position-absolute w-100 align-self-center line-height-4 mb-0">Know Me More<span className="heading-separator-line border-bottom position-abolute d-block mx-auto"></span> </p>
                </div>
                <div className="row">
                    <div className="col-lg-8 text-center text-lg-left">
                        <h2 className="text-7 font-weight-600 mb-3">I'm <span className="text-primary">{dataAbout.nombre}</span>, a Web Developer</h2>
                        <p>{dataAbout.descripcion}</p>
                        <p>{dataAbout.subdescripcion}</p>
                    </div>
                    <div className="col-lg-4 mt-5 mt-lg-0">
                        <div className="pl-4">
                        <ul className="list-style-2">
                            <li className=""><span className="font-weight-600 mr-2">Name:</span>{dataAbout.nombre}</li>
                            <li className=""><span className="font-weight-600 mr-2">Email:</span><span className="color-theme">{dataAbout.email}</span></li>
                            <li className=""><span className="font-weight-600 mr-2">Age:</span>{dataAbout.edad}</li>
                            <li className="border-0"><span className="font-weight-600 mr-2">From:</span>{dataAbout.lugar}</li>
                        </ul>
                        <button type="button" className="btn btn-primary rounded-pill smooth-scroll">Download CV</button> </div>
                    </div>
                </div>
                <div className="brands-grid separator-border mt-5">
                    <div className="row">
                        {estadisticas.map(estadistica => (
                            <TrackVisibility once className="col-6 col-md-4" key={estadistica.titulo}>
                                {({ isVisible }) => isVisible && 
                                    <Suspense fallback={renderLoader()}>
                                        <Estadistica 
                                            estadistica={estadistica}
                                        />
                                    </Suspense>
                                    
                                }
                            </TrackVisibility>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
 
export default About;